import { AppUrls } from 'common/AppUrls'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { signInWithTokenLink } from 'store/actions/auth'

export const useTokenLogin = () => {
    const location = useLocation()
    const { isMultipleTabs } = useSelector((state) => state.global)
    const dispatch = useDispatch()

    // Auth with token link
    useEffect(() => {
        if (location.pathname === AppUrls.tokenLogin && isMultipleTabs === false) {
            dispatch(signInWithTokenLink(location.search))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, location.search, isMultipleTabs])
}
